import React from 'react';
import { Card, CardContent, Typography, Box, Tooltip, IconButton } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import './Dashboard.scss';

const StatCard = ({ title, value, icon, loading = false, breakdown = null, tooltip = null }) => {
  return (
    <Card className="stat-card">
      <CardContent>
        <Box className="stat-card-header">
          {icon && <Box className="stat-card-icon">{icon}</Box>}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1 }}>
            <Typography variant="h6" className="stat-card-title">
              {title}
            </Typography>
            {tooltip && (
              <Tooltip title={tooltip} arrow placement="top">
                <IconButton size="small" sx={{ p: 0.5 }}>
                  <InfoIcon sx={{ fontSize: '1rem', color: '#666' }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Box>
        {loading ? (
          <Typography variant="h4" className="stat-card-value loading">
            ...
          </Typography>
        ) : (
          <>
            <Typography variant="h4" className="stat-card-value">
              {value?.toLocaleString() || '0'}
            </Typography>
            {breakdown && (
              <Box sx={{ display: 'flex', gap: 2, mt: 1, fontSize: '0.875rem', color: 'text.secondary' }}>
                <Typography variant="body2">
                  Free: {breakdown.free?.toLocaleString() || '0'}
                </Typography>
                <Typography variant="body2">
                  Premium: {breakdown.premium?.toLocaleString() || '0'}
                </Typography>
              </Box>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
